module.exports = __webpack_public_path__ + "static/media/personal-website2.7bff0032.png";